module.exports = __webpack_public_path__ + "static/media/traversiere.2775ff85.jpg";